import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/public/Header';
import Footer from '@/components/public/Footer';
import FloatingWhatsApp from '@/components/public/FloatingWhatsApp';
import ScrollToTop from '@/components/public/ScrollToTop';
import { trackEvent } from '@/lib/analytics';

export const PublicLayout = ({ children }) => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
        trackEvent('page_view', pathname);
    }, [pathname]);
    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Header />
            <main className="flex-1">{children}</main>
            <Footer />
            <FloatingWhatsApp />
            <ScrollToTop />
        </div>
    );
};

export default PublicLayout;
